export const CARETEAMS_RECEIVED = 'careteamsReceived'
export const LOADING_CARETEAMS = 'loadingCareteams'
export const CARETEAM_RECEIVED = 'careteamReceived'

export const loadingCareteams = practitioner => ({
  type: LOADING_CARETEAMS,
  payload: practitioner
})

export const receiveCareTeams = careteams => ({
  type: CARETEAMS_RECEIVED,
  payload: careteams
})

export const receiveCareTeam = careteam => ({
  type: CARETEAM_RECEIVED,
  payload: careteam
})



// WEBPACK FOOTER //
// ./src/Careteam/actions.js